import { AtivacaoContratoResultadoDetalhe } from '@app/api/ativacaoContrato';

const ROTULOS_CAMPOS: { [key: string]: string } = {
  NumeroContrato: 'Número do contrato',
  DataInicio: 'Data de início',
  DataTermino: 'Data de término',
  ValorTotal: 'Valor total do contrato',
  ValorTotalBmTotvs: 'Valor total da BM TOTVS',
  CnpjContratada: 'CNPJ da contratada',
  NomeContratada: 'Nome da contratada',
  Objeto: 'Objeto do contrato',
  CondicaoPagamentoDias: 'Prazo de pagamento',
  AdministradorContrato: 'Administrador do contrato',
  Gestor: 'Gestor MRN',
  EmailGestor: 'E-mail do gestor MRN',
  UsuarioGestorId: 'Gestor MRN',
  FiscalId: 'Fiscal do contrato',
  ResponsavelRateioId: 'Responsável pelo rateio',
  ResponsavelContratada: 'Responsável da contratada',
  ResponsavelFornecedorNome: 'Responsável da contratada',
  EmailResponsavel: 'E-mail do responsável da contratada',
  ResponsavelFornecedorEmail: 'E-mail do responsável da contratada',
  ResponsavelFornecedorEmailFinanceiro: 'E-mail financeiro da contratada',
  Diretoria: 'Diretoria',
  Area: 'Área',
  Departamento: 'Departamento',
  Localidade: 'Local de prestação do serviço',
  MaoDeObraAlocadaPTR: 'Mão de Obra Alocada PTR',
  Municipio: 'Município',
  Municipios: 'Local',
  ClassificacaoServicoNivel1: 'Classificação do serviço — Nível 1',
  ClassificacaoServicoNivel2: 'Classificação do serviço — Nível 2',
  ClassificacaoServicoNivel3: 'Classificação do serviço — Nível 3',
  CodItemServico: 'Código do item de serviço',
  DataLimiteInserirMedicao: 'Dia limite para envio da medição',
  DataMensalLimiteInserirMedicao: 'Dia limite para envio da medição',
  DataLimiteValidarMedicao: 'Dia limite para validação da medição',
  DataMensalLimiteValidarMedicao: 'Dia limite para validação da medição',
  DataLimiteReapresentarMedicao: 'Dia limite para reapresentação da medição',
  DataMensalLimiteReapresentarMedicao: 'Dia limite para reapresentação da medição',
  DataLimiteReavaliarMedicao: 'Dia limite para reavaliação da medição',
  DataMensalLimiteReavaliarMedicao: 'Dia limite para reavaliação da medição',
  DataLimiteAutorizarFaturamento: 'Dia limite para autorização do faturamento',
  DataMensalLimiteAutorizarFaturamento: 'Dia limite para autorização do faturamento',
  DataMensalLimiteInserirMedicaoAplicavel: 'Prazo de envio da medição aplicável',
  DataMensalLimiteValidarMedicaoAplicavel: 'Prazo de validação da medição aplicável',
  PossuiSlaMonitorado: 'SLA monitorado',
  AprovacaoPagamentoAutomatica: 'Aprovação automática dos documentos de cobrança',
  IsFaturamentoDireto: 'Faturamento direto',
  IsAdiantamentoFinanceiro: 'Adiantamento financeiro',
  MultiplosGestores: 'Múltiplos gestores',
  UtilizaProcessoRateio: 'Utiliza processo de rateio',
  Reajuste: 'Reajuste contratual',
  ReajusteDataBase: 'Data-base do reajuste',
  ReajusteFrequencia: 'Periodicidade do reajuste',
  ReajusteIndice: 'Índice de reajuste',
  SegurosGarantias: 'Seguros e garantias',
  PossuiSegurosGarantias: 'Possui seguros e garantias',
  PossuiAnexoTratamentoDadosPessoais: 'Anexo de tratamento de dados pessoais',
  Anexos: 'Anexos da minuta',
  Item: 'Item da planilha de quantidades',
  Linha: 'Linha da planilha',
  Quantidade: 'Quantidade',
  ValorUnitario: 'Valor unitário',
  ValorAcumulado: 'Valor acumulado do item',
  ItemValorAnterior: 'Acumulado na BM TOTVS',
  TotalizadorValorAcumulado: 'Total acumulado da medição',
};

const ALIASES_CAMPOS: { [key: string]: string } = {
  PossuiSegurosGarantias: 'SegurosGarantias',
  DataLimiteInserirMedicao: 'DataMensalLimiteInserirMedicao',
  DataLimiteValidarMedicao: 'DataMensalLimiteValidarMedicao',
  DataLimiteReapresentarMedicao: 'DataMensalLimiteReapresentarMedicao',
  DataLimiteReavaliarMedicao: 'DataMensalLimiteReavaliarMedicao',
  DataLimiteAutorizarFaturamento: 'DataMensalLimiteAutorizarFaturamento',
  Gestor: 'UsuarioGestorId',
  EmailGestor: 'UsuarioGestorId',
  ResponsavelContratada: 'ResponsavelFornecedorNome',
  EmailResponsavel: 'ResponsavelFornecedorEmail',
  Localidade: 'MaoDeObraAlocadaPTR',
  Reajuste: 'ReajusteIndice',
};

const CAMPOS_DIA_MES = [
  'DataLimiteInserirMedicao',
  'DataMensalLimiteInserirMedicao',
  'DataLimiteValidarMedicao',
  'DataMensalLimiteValidarMedicao',
  'DataLimiteReapresentarMedicao',
  'DataMensalLimiteReapresentarMedicao',
  'DataLimiteReavaliarMedicao',
  'DataMensalLimiteReavaliarMedicao',
  'DataLimiteAutorizarFaturamento',
  'DataMensalLimiteAutorizarFaturamento',
];

const CAMPOS_MONETARIOS = [
  'ValorTotal',
  'ValorTotalBmTotvs',
  'ValorUnitario',
  'ValorAcumulado',
  'ItemValorAnterior',
  'TotalizadorValorAcumulado',
];

export const campoCanonico = (campo: string | null) => {
  if (!campo) return campo;
  return ALIASES_CAMPOS[campo] || campo;
};

const humanizarCampoDesconhecido = (campo: string) =>
  campo
    .replace(/([a-zá-ú0-9])([A-Z])/g, '$1 $2')
    .replace(/\bCnpj\b/g, 'CNPJ')
    .replace(/\bSla\b/g, 'SLA')
    .replace(/\bMrn\b/g, 'MRN')
    .replace(/\bPq\b/g, 'PQ')
    .replace(/\bBm\b/g, 'BM')
    .replace(/\bId\b/g, 'ID');

export const rotuloCampo = (item: AtivacaoContratoResultadoDetalhe) => {
  if (!item.campo) return item.chaveItem || 'Validação da etapa';
  if (item.campo === 'ValorTotal' && item.chaveItem) return 'Valor total do item';
  return ROTULOS_CAMPOS[item.campo] || humanizarCampoDesconhecido(item.campo);
};

const numeroInteiro = (valor: string) => /^\d+$/.test(valor.trim());

const formatarCnpj = (valor: string) => {
  const digitos = valor.replace(/\D/g, '');
  if (digitos.length !== 14) return valor;
  return digitos.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
};

const converterDecimal = (valor: string) => {
  const limpo = valor.replace(/R\$\s?/gi, '').trim();
  if (!/^-?[\d.,]+$/.test(limpo)) return null;
  const ultimaVirgula = limpo.lastIndexOf(',');
  const ultimoPonto = limpo.lastIndexOf('.');
  const separadorDecimal = ultimaVirgula > ultimoPonto ? ',' : '.';
  const normalizado = separadorDecimal === ',' ? limpo.replace(/\./g, '').replace(',', '.') : limpo.replace(/,/g, '');
  const numero = Number(normalizado);
  return !isNaN(numero) && isFinite(numero) ? numero : null;
};

const formatarMoeda = (valor: string) => {
  const numero = converterDecimal(valor);
  if (numero === null) return valor;
  return numero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const formatarValorCampo = (item: AtivacaoContratoResultadoDetalhe, valor: string | null) => {
  if (!valor) return null;
  const campo = item.campo || '';
  if (campo === 'CnpjContratada') return formatarCnpj(valor);
  if (campo === 'CondicaoPagamentoDias' && numeroInteiro(valor)) return `${Number(valor)} dias`;
  if (campo === 'ReajusteFrequencia' && numeroInteiro(valor)) return `A cada ${Number(valor)} meses`;
  if (CAMPOS_DIA_MES.indexOf(campo) >= 0 && numeroInteiro(valor)) return `Dia ${Number(valor)}`;
  if (CAMPOS_MONETARIOS.indexOf(campo) >= 0) return formatarMoeda(valor);
  return valor;
};

export const formatarMensagemCampos = (mensagem: string | null) => {
  if (!mensagem) return null;
  return Object.keys(ROTULOS_CAMPOS)
    .sort((a, b) => b.length - a.length)
    .reduce((texto, campo) => texto.replace(new RegExp(`\\b${campo}\\b`, 'g'), ROTULOS_CAMPOS[campo]), mensagem);
};
